import React, { Component, Fragment } from 'react';
import { Col, Container, Row } from "react-bootstrap";
import Cabo from '../assets/CABITO 02.png';
import banner from '../assets/bannerpet.png';

class Petitions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            petitionCSS: "https://radio.amgroupmkt.com:1030/media/static/css/request_track_widget/request_widget.css",
            serverId: props.serverId
        };
        this.widgetRef = React.createRef(); // Referencia para el elemento que contendrá el widget
    }

    loadScript = () => {
        const script = document.createElement("script");
        script.src = "https://radio.amgroupmkt.com:1030/media/static/js/request_track_widget/request_widget.js";
        script.async = true;

        script.onload = () => {
            // Asegurarse de que el script se inicialice correctamente
            this.initializeWidget();
        };

        document.body.appendChild(script);
    }

    initializeWidget = () => {
        // Colocar aquí la lógica de inicialización si es necesaria
    }

    componentDidMount() {
        if (this.widgetRef.current) {
            this.loadScript();
        }
    }

    componentWillUnmount() {
        // Limpieza del script para evitar referencias colgantes
        const allScripts = document.getElementsByTagName('script');
        [...allScripts].forEach(script => {
            if (script.src === "https://radio.amgroupmkt.com:1030/media/static/js/request_track_widget/request_widget.js") {
                script.remove();
            }
        });
    }

    render() {
        return (
            <Fragment>
                <link rel="stylesheet" type="text/css" href={this.state.petitionCSS} />
                <Container>
                    <Row>
                        <Col className="align-self-center" md={8} lg={8}>
                            <div className="sc-track-request-widget" ref={this.widgetRef}>
                                {/* El widget será inicializado por el script externo */}
                                <div is="track-request-widget"
                                        lang="en"
                                        api-base="https://radio.amgroupmkt.com:1030/api/v2"
                                        server-id={this.state.serverId}
                                        ip-timeout="0"
                                        track-timeout="0"
                                        bgcolor="#ffffff"
                                        bgopacity="0"
                                        tracks_num="10"
                                        track_width="130"
                                        track_image_default="https://radio.amgroupmkt.com:1030/media/widgets/am_radio_64x64.png"
                                        meta_font_size="14"
                                        meta_font_style="normal"
                                        meta_font_color="#ffffff"
                                        meta_opacity="1"
                                        button_color="#4165b9"
                                        button_color_active="#bdbf91"
                                        button_font_color="#ffffff"
                                        button_font_size="14"
                                        ordering="1"
                                        allow_person_and_message="true"
                                        modal_background_color="#ffffff"
                                        modal_font_color="#000000"
                                        modal_background_opacity="1"
                                    >
                                </div>
                            </div>
                        </Col>
                        <Col className="align-self-center" md={4} lg={4}>
                            <img src={banner} width="400" alt="Banner" />
                            <img src={Cabo} width="200" alt="Cabo" />
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        );
    }
}

export default Petitions;
